import { render, staticRenderFns } from "./OnePagePreview.vue?vue&type=template&id=e895c8e0&scoped=true&"
import script from "./OnePagePreview.vue?vue&type=script&lang=js&"
export * from "./OnePagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e895c8e0",
  null
  
)

export default component.exports